/**
 * Telemetry jobs finishing — read from the notifications poll.
 *
 * A telemetry portfolio is read by the server in the background; the sidebar
 * shows Pending / In Progress on its row (dashboard slice `telemetryJobStatus`,
 * keyed by portfolio id). When the server is done it sends a notification
 * whose title mentions "telemetry", carrying the portfolio's id — and the mark
 * goes (legacy Headerbar.vue pollNotifications :654-680).
 *
 * Legacy matched by NAME and kept a "seen" set; its first poll found the set
 * empty and cleared marks on the strength of OLD notifications. Here a mark is
 * only cleared by an unread notification for THAT portfolio id, and a mark
 * only exists for a portfolio saved in this session — so an old notification
 * cannot clear a new mark.
 */

/** Is this notification about a telemetry job? (legacy: title contains "telemetry") */
export function isTelemetryNotification(notification) {
  return /telemetry/i.test(String(notification?.title ?? ''));
}

/**
 * The portfolio ids whose mark these notifications clear: unread, about
 * telemetry, for a portfolio that still has a mark.
 *
 * @param {object[]} notifications  the poll's items
 * @param {Record<string, string>} jobs  portfolio id -> 'pending' | 'in_progress'
 * @returns {string[]}
 */
export function finishedTelemetryJobs(notifications, jobs) {
  const ids = new Set();
  for (const n of notifications ?? []) {
    const id = n?.portfolio_id;
    if (!n?.is_seen && id && jobs?.[id] && isTelemetryNotification(n)) ids.add(id);
  }
  return [...ids];
}
